import React from 'react';
import { Link } from 'react-router-dom';
import Certificate from "../images/cert.jpg";
import Seo from '../components/Seo';

/* ─── PALETTE ─────────────────────────────────────────────── */
const V1 = '#7F00FF';
const V2 = '#B163FF';
const V3 = '#51158C';
const V4 = '#2B0057';

/* ─── SVG ICONS ───────────────────────────────────────────── */
const TargetIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" /><circle cx="12" cy="12" r="6" /><circle cx="12" cy="12" r="2" />
  </svg>
);
const UsersIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);
const TrendingUpIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" /><polyline points="17 6 23 6 23 12" />
  </svg>
);
const GlobeIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <line x1="2" y1="12" x2="22" y2="12" />
    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
  </svg>
);
const LinkedInIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
    <rect x="2" y="9" width="4" height="12" /><circle cx="4" cy="4" r="2" />
  </svg>
);

/* ─── DATA ────────────────────────────────────────────────── */
const values = [
  { Icon: TargetIcon, title: 'Quality First', desc: 'Every course is meticulously designed by industry experts to ensure real-world relevance.' },
  { Icon: UsersIcon, title: 'Community Driven', desc: 'We believe in building a supportive community where students learn from each other.' },
  { Icon: TrendingUpIcon, title: 'Career Focused', desc: 'Our programs are built specifically to boost your employability and career prospects.' },
  { Icon: GlobeIcon, title: 'Accessible', desc: 'Quality education in Tamil for students across Tamil Nadu, breaking language barriers.' },
];

const teamMembers = [
  { name: 'Arunachalam', role: 'Founder & CEO', bio: 'Full-Stack Visionary', img: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&q=80' },
  { name: 'Priya Sharma', role: 'CTO', bio: 'Tech Architecture Expert', img: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&q=80' },
  { name: 'Suresh Kumar', role: 'Head of Curriculum', bio: 'Industry Expert', img: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=200&q=80' },
  { name: 'Divya Lakshmi', role: 'Student Success Lead', bio: 'Mentor & Coach', img: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=200&q=80' },
];

const milestones = [
  { year: '2026', event: 'ThiranX Founded', desc: 'Started with vision to revolutionize tech education in Tamil Nadu' },
  { year: '2026', event: 'MSME Registered', desc: 'Officially recognized as a registered institution' },
  { year: '2026', event: 'Platform Launch', desc: 'Launched our modern learning platform for students' },
  { year: '2026', event: 'First Batch Enrollment', desc: 'Accepting enrollments for our first batch of tech courses' },
];

/* ─── CIRCUIT BG ──────────────────────────────────────────── */
const CircuitBg = () => (
  <div style={{ position: 'absolute', inset: 0, pointerEvents: 'none', overflow: 'hidden', zIndex: 0, opacity: 0.07 }}>
    <svg viewBox="0 0 1400 800" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" style={{ width: '100%', height: '100%' }}>
      <g stroke={V2} strokeWidth="0.9" fill="none">
        <line x1="0" y1="160" x2="320" y2="160" /><line x1="380" y1="160" x2="680" y2="160" />
        <line x1="980" y1="120" x2="1400" y2="120" />
        <line x1="0" y1="420" x2="210" y2="420" /><line x1="570" y1="420" x2="880" y2="420" />
        <line x1="0" y1="660" x2="460" y2="660" /><line x1="810" y1="660" x2="1400" y2="660" />
        <line x1="320" y1="0" x2="320" y2="260" /><line x1="680" y1="120" x2="680" y2="260" />
        <line x1="880" y1="340" x2="880" y2="500" /><line x1="210" y1="360" x2="210" y2="500" />
        <circle cx="320" cy="160" r="5" fill={V1} opacity="0.9" />
        <circle cx="680" cy="160" r="4" fill={V2} opacity="0.9" />
        <circle cx="210" cy="420" r="4" fill={V2} opacity="0.9" />
        <circle cx="570" cy="420" r="5" fill={V1} opacity="0.9" />
        <circle cx="460" cy="660" r="5" fill={V1} opacity="0.9" />
        <circle cx="320" cy="260" r="7" stroke={V2} strokeWidth="1.5" fill="none" />
        <circle cx="880" cy="340" r="7" stroke={V1} strokeWidth="1.5" fill="none" />
      </g>
    </svg>
  </div>
);

/* ─── MAIN ────────────────────────────────────────────────── */
const About = () => {
  return (
    <div style={{ background: 'var(--bg)', color: 'var(--text)' }}>
      <Seo
        title="About Us"
        description="Learn about ThiranX's mission to empower Tamil Nadu's next generation of tech professionals with industry-focused courses, real internships, and verified certificates."
        path="/about"
      />

      {/* ══ HERO ════════════════════════════════════════════ */}
      <section style={{
        minHeight: '100vh', display: 'flex', alignItems: 'center',
        position: 'relative', overflow: 'hidden',
        padding: '120px 0 90px',
        background: 'var(--bg)',
      }}>
        <CircuitBg />
        <div style={{ position: 'absolute', bottom: '0', right: '0', width: 420, height: 420, borderRadius: '50%', background: `radial-gradient(circle, var(--hero-orb) 0%, transparent 70%)`, pointerEvents: 'none' }} />

        <div className="container" style={{ position: 'relative', zIndex: 2 }}>
          <div style={{ textAlign: 'center', maxWidth: 700, margin: '0 auto' }}>
            <div style={{
              display: 'inline-flex', alignItems: 'center', gap: 8,
              border: '1px solid var(--badge-pill-border)', borderRadius: 999,
              padding: '6px 18px', marginBottom: 36,
              fontSize: 11.5, fontWeight: 800, color: 'var(--badge-pill-text)',
              letterSpacing: '0.08em', textTransform: 'uppercase',
              background: 'var(--badge-pill-bg)',
            }}>
              <span style={{ width: 6, height: 6, borderRadius: '50%', background: V2 }} />
              About ThiranX
            </div>

            <h1 style={{
              fontSize: 'clamp(44px,7vw,88px)',
              fontWeight: 800, lineHeight: 1.04,
              letterSpacing: '-0.03em', marginBottom: 24,
              fontFamily: "'Inter',sans-serif",
            }}>
              Transforming Tech Education<br />
              <span style={{
                background: `linear-gradient(135deg,${V1},${V2})`,
                WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text',
              }}>in Tamil Nadu</span>
            </h1>

            <p style={{
              color: 'var(--text-2)', fontSize: 'clamp(15px,1.8vw,18px)',
              maxWidth: 520, lineHeight: 1.8, marginBottom: 44, margin: '0 auto 44px',
            }}>
              ThiranX was founded with a simple mission: to make world-class tech education accessible to every student in Tamil Nadu through their native language.
            </p>

            <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
              <Link to="/courses" className="btn btn-primary" style={{ fontSize: 15, padding: '14px 36px' }}>Explore Courses</Link>
              <Link to="/register" className="btn btn-ghost" style={{ fontSize: 15, padding: '14px 32px' }}>Get Started →</Link>
            </div>
          </div>
        </div>
      </section>

      {/* ══ OUR VALUES ═════════════════════════════════════ */}
      <section style={{ padding: '120px 0', background: 'var(--bg2)', borderBottom: '1px solid var(--border)' }}>
        <div className="container" style={{ position: 'relative', zIndex: 1 }}>
          <div style={{ textAlign: 'center', marginBottom: 60 }}>
            <div className="section-label">VALUES</div>
            <h2 style={{ fontSize: 'clamp(30px,4vw,52px)', fontWeight: 800, letterSpacing: '-0.025em', marginBottom: 12 }}>
              What Drives Us
            </h2>
            <p style={{ color: 'var(--muted)', fontSize: 16, maxWidth: 400, margin: '0 auto' }}>Core principles that guide every decision we make</p>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: 28 }}>
            {values.map(({ Icon, title, desc }, i) => (
              <div key={i} className="card" style={{ textAlign: 'center', padding: '40px 28px' }}>
                <div style={{
                  width: 64, height: 64, borderRadius: 16, margin: '0 auto 20px',
                  background: `linear-gradient(135deg,${V4},${V3})`,
                  border: `1px solid ${V1}44`,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  color: V2,
                }}>
                  <Icon />
                </div>
                <h3 style={{ fontSize: 18, fontWeight: 800, marginBottom: 10, letterSpacing: '-0.01em' }}>{title}</h3>
                <p style={{ color: 'var(--muted)', fontSize: 14, lineHeight: 1.6 }}>{desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══ OUR STORY ═══════════════════════════════════════ */}
      <section style={{ padding: '120px 0', background: 'var(--bg)', position: 'relative', overflow: 'hidden' }}>
        <CircuitBg />
        <div className="container" style={{ position: 'relative', zIndex: 1 }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 60, alignItems: 'center' }} className="story-grid">
            {/* Left */}
            <div>
              <div className="section-label">STORY</div>
              <h2 style={{ fontSize: 'clamp(30px,4vw,48px)', fontWeight: 800, letterSpacing: '-0.025em', marginBottom: 24 }}>
                How It All<br />
                <span style={{
                  background: `linear-gradient(135deg,${V1},${V2})`,
                  WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text',
                }}>Started</span>
              </h2>
              <p style={{ color: 'var(--text-2)', fontSize: 16.5, lineHeight: 1.8, marginBottom: 20 }}>
                In 2026, our founder realized a critical gap: thousands of talented students in Tamil Nadu were being left behind because quality tech education wasn't available in their language. Most struggled with English-medium content, and those who couldn't afford expensive Bangalore-based programs were completely out.
              </p>
              <p style={{ color: 'var(--text-2)', fontSize: 16.5, lineHeight: 1.8, marginBottom: 20 }}>
                What started as a simple idea quickly became a movement. We built a platform where industry experts teach live classes in Tamil, where concepts are explained in familiar context, and where every student gets personalized mentorship.
              </p>
              <p style={{ color: 'var(--text-2)', fontSize: 16.5, lineHeight: 1.8 }}>
                Today, we are officially launching ThiranX to transform careers across Tamil Nadu, and we're just getting started.
              </p>
            </div>

            {/* Right - Image */}
            <div style={{
              borderRadius: 24, overflow: 'hidden',
              clipPath: 'polygon(0 0, 100% 0, 100% 88%, 88% 100%, 0 100%)',
              aspectRatio: '4/5', maxHeight: 520,
              boxShadow: '0 32px 80px rgba(0,0,0,0.5)',
            }}>
              <img src="https://images.unsplash.com/photo-1552664730-d307ca884978?w=900&q=80" alt="Our Story" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            </div>
          </div>
        </div>
      </section>

      {/* ══ MILESTONES ══════════════════════════════════════ */}
      <section style={{ padding: '120px 0', background: 'var(--bg2)' }}>
        <div className="container" style={{ position: 'relative', zIndex: 1 }}>
          <div style={{ textAlign: 'center', marginBottom: 60 }}>
            <div className="section-label">JOURNEY</div>
            <h2 style={{ fontSize: 'clamp(30px,4vw,52px)', fontWeight: 800, letterSpacing: '-0.025em', marginBottom: 12 }}>
              Milestones
            </h2>
            <p style={{ color: 'var(--muted)', fontSize: 16, maxWidth: 400, margin: '0 auto' }}>Our growth story in numbers</p>
          </div>

          <div style={{
            display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: 24,
            position: 'relative',
          }}>
            {milestones.map((m, i) => (
              <div key={i} className="card" style={{
                padding: '32px 24px', borderLeft: `4px solid ${V1}`, position: 'relative',
              }}>
                <div style={{
                  fontFamily: "'Inter',sans-serif", fontWeight: 900,
                  fontSize: 32, color: V2, marginBottom: 8, lineHeight: 1,
                }}>{m.year}</div>
                <h3 style={{ fontSize: 16, fontWeight: 800, marginBottom: 8 }}>{m.event}</h3>
                <p style={{ color: 'var(--muted)', fontSize: 13, lineHeight: 1.6 }}>{m.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* /* ══ TEAM (Hidden for now) ════════════════════════════
      <section style={{ padding: '120px 0', background: 'var(--bg)', position: 'relative', overflow: 'hidden' }}>
        <CircuitBg />
        <div className="container" style={{ position: 'relative', zIndex: 1 }}>
          <div style={{ textAlign: 'center', marginBottom: 60 }}>
            <div className="section-label">TEAM</div>
            <h2 style={{ fontSize: 'clamp(30px,4vw,52px)', fontWeight: 800, letterSpacing: '-0.025em', marginBottom: 12 }}>
              Meet Our <span style={{
                background: `linear-gradient(135deg,${V1},${V2})`,
                WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text',
              }}>Leaders</span>
            </h2>
            <p style={{ color: 'var(--muted)', fontSize: 16, maxWidth: 400, margin: '0 auto' }}>Passionate experts dedicated to your success</p>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 32 }}>
            {teamMembers.map((m, i) => (
              <div key={i} style={{ textAlign: 'center' }}>
                <div style={{
                  width: 160, height: 160, margin: '0 auto 20px',
                  borderRadius: 20, overflow: 'hidden',
                  border: `2px solid ${V1}44`,
                  boxShadow: `0 12px 40px rgba(0,0,0,0.2), 0 0 0 1px ${V1}22`,
                  transition: 'box-shadow 0.25s, transform 0.25s',
                }}
                  onMouseEnter={e => { e.currentTarget.style.boxShadow = `0 20px 56px rgba(0,0,0,0.3), 0 0 0 2px ${V1}66`; e.currentTarget.style.transform = 'translateY(-4px)'; }}
                  onMouseLeave={e => { e.currentTarget.style.boxShadow = `0 12px 40px rgba(0,0,0,0.2), 0 0 0 1px ${V1}22`; e.currentTarget.style.transform = ''; }}
                >
                  <img src={m.img} alt={m.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                </div>
                <h3 style={{ fontSize: 16, fontWeight: 800, marginBottom: 4, fontFamily: "'Inter',sans-serif" }}>{m.name}</h3>
                <div style={{ color: V2, fontSize: 13, fontWeight: 700, marginBottom: 6 }}>{m.role}</div>
                <p style={{ color: 'var(--muted)', fontSize: 13 }}>{m.bio}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      ════════════════════════════════════════════════════════  */}

      {/* ══ CERTIFICATIONS ══════════════════════════════════ */}
      <section style={{ padding: '120px 0', background: 'var(--bg2)', position: 'relative', overflow: 'hidden' }}>
        <CircuitBg />

        {/* Ambient orbs */}
        <div style={{ position: 'absolute', top: '10%', left: '-8%', width: 420, height: 420, borderRadius: '50%', background: `radial-gradient(circle,${V1}18 0%,transparent 70%)`, pointerEvents: 'none', zIndex: 0 }} />
        <div style={{ position: 'absolute', bottom: '5%', right: '-6%', width: 320, height: 320, borderRadius: '50%', background: `radial-gradient(circle,${V2}14 0%,transparent 70%)`, pointerEvents: 'none', zIndex: 0 }} />

        <div className="container" style={{ position: 'relative', zIndex: 1 }}>

          {/* Section header */}
          <div style={{ textAlign: 'center', marginBottom: 72 }}>
            <div className="section-label">RECOGNITION</div>
            <h2 style={{ fontSize: 'clamp(30px,4vw,54px)', fontWeight: 800, letterSpacing: '-0.025em', marginBottom: 14 }}>
              Certified &amp; <span style={{ background: `linear-gradient(135deg,${V1},${V2})`, WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text' }}>Recognised</span>
            </h2>
            <p style={{ color: 'var(--muted)', fontSize: 16, maxWidth: 460, margin: '0 auto' }}>
              Our programs are officially certified and recognised by government &amp; industry bodies — giving your certificate real-world credibility.
            </p>
          </div>

          {/* Main MSME card */}
          <div style={{
            background: 'var(--card-solid)',
            border: '1px solid var(--border)',
            borderRadius: 28,
            padding: 'clamp(32px,5vw,60px)',
            boxShadow: `0 32px 80px rgba(0,0,0,0.18), 0 0 0 1px ${V1}18`,
            marginBottom: 32,
          }}>
            <div style={{
              display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 56,
              alignItems: 'center',
            }} className="cert-grid">

              {/* Left — certificate image frame */}
              <div style={{ position: 'relative' }}>

                {/* Animated glow ring */}
                <div style={{
                  position: 'absolute', inset: -3,
                  borderRadius: 22,
                  background: `linear-gradient(135deg,${V1},${V2},${V3},${V1})`,
                  backgroundSize: '300% 300%',
                  animation: 'certGlow 4s linear infinite',
                  zIndex: 0,
                  opacity: 0.7,
                }} />

                {/* Outer frame */}
                <div style={{
                  position: 'relative', zIndex: 1,
                  borderRadius: 20,
                  overflow: 'hidden',
                  aspectRatio: '4/3',
                  boxShadow: `0 24px 64px rgba(0,0,0,0.3)`,
                  background: 'var(--bg)',
                }}>
                  <img
                    src={Certificate}
                    alt="MSME Certificate"
                    style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                  />

                  {/* MSME stamp overlay — desktop only */}
                  <div className="msme-badge-overlay" style={{
                    position: 'absolute', top: 14, right: 14,
                    background: `linear-gradient(135deg,${V1},${V3})`,
                    borderRadius: 10, padding: '6px 12px',
                    display: 'flex', alignItems: 'center', gap: 6,
                    boxShadow: '0 4px 16px rgba(0,0,0,0.35)',
                    backdropFilter: 'blur(8px)',
                    zIndex: 2,
                  }}>
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                    </svg>
                    <span style={{ color: '#fff', fontSize: 10.5, fontWeight: 800, letterSpacing: '0.06em', textTransform: 'uppercase' }}>MSME Certified</span>
                  </div>

                  {/* Decorative corner brackets */}
                  {[
                    { top: 0, left: 0, borderTop: `3px solid ${V2}`, borderLeft: `3px solid ${V2}` },
                    { top: 0, right: 0, borderTop: `3px solid ${V2}`, borderRight: `3px solid ${V2}` },
                    { bottom: 0, left: 0, borderBottom: `3px solid ${V2}`, borderLeft: `3px solid ${V2}` },
                    { bottom: 0, right: 0, borderBottom: `3px solid ${V2}`, borderRight: `3px solid ${V2}` },
                  ].map((s, i) => (
                    <div key={i} style={{ position: 'absolute', width: 20, height: 20, ...s, opacity: 0.8 }} />
                  ))}

                  {/* Bottom gradient fade */}
                  <div style={{
                    position: 'absolute', bottom: 0, left: 0, right: 0, height: 60,
                    background: 'linear-gradient(to top,rgba(0,0,0,0.45),transparent)',
                  }} />
                </div>

                {/* MSME badge — mobile only (below image) */}

              </div>

              <div className="msme-badge-mobile" style={{
                display: 'none', alignItems: 'center', justifyContent: 'center', gap: 8,
                background: `linear-gradient(135deg,${V1},${V3})`,
                borderRadius: 12, padding: '10px 20px',
                marginTop: 16,
                boxShadow: `0 4px 16px ${V1}44`,
              }}>
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                </svg>
                <span style={{ color: '#fff', fontSize: 12, fontWeight: 800, letterSpacing: '0.06em', textTransform: 'uppercase' }}>MSME Certified Institution</span>
              </div>

              {/* Right — MSME details */}
              <div>
                {/* Gov certified pill */}
                <div style={{
                  display: 'inline-flex', alignItems: 'center', gap: 8,
                  background: `linear-gradient(135deg,${V1}22,${V2}15)`,
                  border: `1.5px solid ${V1}55`,
                  borderRadius: 999, padding: '7px 18px',
                  marginBottom: 24,
                }}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={V2} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                  </svg>
                  <span style={{ fontSize: 11, fontWeight: 800, color: V2, letterSpacing: '0.08em', textTransform: 'uppercase' }}>Government of India Certified</span>
                </div>

                <h3 style={{
                  fontSize: 'clamp(26px,3vw,42px)', fontWeight: 900, letterSpacing: '-0.025em',
                  fontFamily: "'Inter',sans-serif", marginBottom: 6, lineHeight: 1.1,
                }}>
                  MSME
                </h3>
                <h3 style={{
                  fontSize: 'clamp(26px,3vw,42px)', fontWeight: 900, letterSpacing: '-0.025em',
                  fontFamily: "'Inter',sans-serif", marginBottom: 20, lineHeight: 1.1,
                  background: `linear-gradient(135deg,${V1},${V2})`,
                  WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text',
                }}>
                  Certified Institution
                </h3>

                {/* Divider line */}
                <div style={{ width: 48, height: 3, borderRadius: 999, background: `linear-gradient(90deg,${V1},${V2})`, marginBottom: 22 }} />

                <p style={{ color: 'var(--text-2)', fontSize: 15.5, lineHeight: 1.8, marginBottom: 28 }}>
                  ThiranX is officially registered under the <strong style={{ color: 'var(--text)' }}>Ministry of Micro, Small &amp; Medium Enterprises (MSME)</strong>, Government of India — ensuring your certification carries national credibility and professional weight.
                </p>

                {/* Key points */}
                {[
                  { label: 'Government of India recognised institution' },
                  { label: 'Certificates valid for placements &amp; higher education' },
                  { label: 'Compliant with national skill development standards' },
                  { label: 'Udyam Registration verified &amp; active' },
                ].map(({ label }, i) => (
                  <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 13 }}>
                    <div style={{
                      width: 24, height: 24, borderRadius: 7, flexShrink: 0,
                      background: `linear-gradient(135deg,${V1},${V3})`,
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      boxShadow: `0 2px 8px ${V1}44`,
                    }}>
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="20 6 9 17 4 12" />
                      </svg>
                    </div>
                    <span style={{ color: 'var(--text-2)', fontSize: 14.5, lineHeight: 1.5 }} dangerouslySetInnerHTML={{ __html: label }} />
                  </div>
                ))}

                {/* Stats strip */}
                <div style={{
                  display: 'flex', gap: 24, marginTop: 32, paddingTop: 24,
                  borderTop: '1px solid var(--border)',
                  flexWrap: 'wrap',
                }}>
                  {[
                    { value: '2026', label: 'Registered Since' },
                    { value: '100%', label: 'Govt. Recognised' },
                  ].map(({ value, label }, i) => (
                    <div key={i}>
                      <div style={{ fontFamily: "'Inter',sans-serif", fontWeight: 900, fontSize: 22, color: V2, lineHeight: 1 }}>{value}</div>
                      <div style={{ color: 'var(--muted)', fontSize: 12, marginTop: 4, fontWeight: 600 }}>{label}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Recognition badges row */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(190px, 1fr))', gap: 18 }}>
            {[
              { icon: '🏛️', title: 'MSME Registered', desc: 'Udyam Registration verified', color: V1 },
              { icon: '📜', title: 'Quality Standards', desc: 'Adherent to quality frameworks', color: '#00B4D8' },
              { icon: '🤝', title: 'Industry Partners', desc: 'Tied up with top tech companies', color: '#06D6A0' },
              { icon: '🎓', title: 'Skill India Aligned', desc: 'Aligned with national skill mission', color: '#FFB703' },
            ].map(({ icon, title, desc, color }, i) => (
              <div key={i}
                className="card"
                style={{
                  padding: '28px 22px', textAlign: 'center',
                  border: `1.5px solid ${color}28`,
                  background: `linear-gradient(145deg,var(--card-solid),var(--bg3))`,
                  transition: 'transform 0.22s, box-shadow 0.22s, border-color 0.22s',
                  cursor: 'default',
                }}
                onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-5px)'; e.currentTarget.style.boxShadow = `0 16px 40px ${color}22`; e.currentTarget.style.borderColor = `${color}66`; }}
                onMouseLeave={e => { e.currentTarget.style.transform = ''; e.currentTarget.style.boxShadow = ''; e.currentTarget.style.borderColor = `${color}28`; }}
              >
                <div style={{
                  width: 52, height: 52, borderRadius: 14, margin: '0 auto 16px',
                  background: `${color}18`,
                  border: `1.5px solid ${color}33`,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: 24,
                }}>{icon}</div>
                <div style={{ fontWeight: 800, fontSize: 14, marginBottom: 6 }}>{title}</div>
                <div style={{ color: 'var(--muted)', fontSize: 12.5, lineHeight: 1.55 }}>{desc}</div>
              </div>
            ))}
          </div>
        </div>

        <style>{`
          @keyframes certGlow {
            0%   { background-position: 0% 50%; }
            50%  { background-position: 100% 50%; }
            100% { background-position: 0% 50%; }
          }
        `}</style>
      </section>


      {/* ══ CTA ═════════════════════════════════════════════ */}
      <section style={{ padding: '80px 0 110px', background: 'var(--bg2)' }}>
        <div className="container">
          <div style={{
            borderRadius: 28, overflow: 'hidden', position: 'relative',
            background: `linear-gradient(135deg,${V4} 0%,${V3} 50%,${V1} 100%)`,
            padding: 'clamp(60px,8vw,100px) clamp(32px,6vw,80px)',
            textAlign: 'center',
            clipPath: 'polygon(0 0, 100% 0, 100% 88%, 96% 100%, 0 100%)',
          }}>
            <CircuitBg />
            <div style={{ position: 'relative', zIndex: 1 }}>
              <div className="section-label" style={{ background: 'rgba(255,255,255,0.10)', borderColor: 'rgba(255,255,255,0.18)', color: 'rgba(255,255,255,0.8)' }}>JOIN US</div>
              <h2 style={{ fontSize: 'clamp(34px,5vw,62px)', fontWeight: 900, color: '#fff', marginBottom: 18, letterSpacing: '-0.03em', fontFamily: "'Inter',sans-serif" }}>
                Be Part of the<br />Revolution
              </h2>
              <p style={{ color: 'rgba(255,255,255,0.72)', fontSize: 17, maxWidth: 460, margin: '0 auto 48px', lineHeight: 1.78 }}>
                Start your journey with ThiranX today and transform your future.
              </p>
              <div style={{ display: 'flex', gap: 14, justifyContent: 'center', flexWrap: 'wrap' }}>
                <Link to="/register" style={{
                  display: 'inline-flex', alignItems: 'center', gap: 8,
                  background: '#ffffff', color: V1, padding: '16px 44px', borderRadius: 12,
                  fontWeight: 800, fontSize: 15,
                  boxShadow: '0 8px 32px rgba(0,0,0,0.22)',
                  transition: 'all 0.22s cubic-bezier(.34,1.56,.64,1)',
                }}
                  onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-3px)'; e.currentTarget.style.boxShadow = '0 16px 48px rgba(0,0,0,0.3)'; }}
                  onMouseLeave={e => { e.currentTarget.style.transform = ''; e.currentTarget.style.boxShadow = '0 8px 32px rgba(0,0,0,0.22)'; }}
                >Start Learning Today</Link>
                <Link to="/courses" style={{
                  display: 'inline-flex', alignItems: 'center',
                  background: 'rgba(255,255,255,0.10)', color: '#fff',
                  padding: '16px 36px', borderRadius: 12, fontWeight: 700, fontSize: 15,
                  border: '1.5px solid rgba(255,255,255,0.22)',
                  transition: 'all 0.2s',
                }}
                  onMouseEnter={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.18)'; }}
                  onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.10)'; }}
                >Browse Courses</Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <style>{`
        @keyframes pulseGlow { 0%,100%{opacity:.4} 50%{opacity:1} }
        @media (max-width:960px) {
          .story-grid { grid-template-columns:1fr!important; }
          .cert-grid  { grid-template-columns:1fr!important; gap:36px!important; }
          .msme-badge-overlay { display:none!important; }
          .msme-badge-mobile  { display:flex!important; }
        }
      `}</style>
    </div>
  );
};

export default About;
